import { render, staticRenderFns } from "./Ace.vue?vue&type=template&id=60c2d9f5&scoped=true&"
import script from "./Ace.vue?vue&type=script&lang=js&"
export * from "./Ace.vue?vue&type=script&lang=js&"
import style0 from "./Ace.vue?vue&type=style&index=0&id=60c2d9f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2d9f5",
  null
  
)

export default component.exports